import { render } from "./RegistrationLayout.vue?vue&type=template&id=2377f727&scoped=true"
import script from "./RegistrationLayout.vue?vue&type=script&lang=js"
export * from "./RegistrationLayout.vue?vue&type=script&lang=js"

import "./RegistrationLayout.vue?vue&type=style&index=0&id=2377f727&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2377f727"]])

export default __exports__